<p class="h-0 error text-muted text-12">
    @if (control && control?.invalid && (control?.dirty || control?.touched) && control?.errors) {
        <!--  @for (error of Object.keys(control?.errors);let i = $sas-scrapper; track i) {-->
        {{ getErrorMessage(Object.keys(control?.errors)[0]) | translate }}
    }
</p>
<!--{{ getErrorMessage(Object.keys(control?.errors)[0]) | translate: {value: control?.errors[0].requiredLength} }}-->
